import type { IconProps } from './types';

export const UnregisteredOnboardingStateIcon: React.FC<IconProps> = (props) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_120_616)">
                <path d="M3 8H13" stroke="#738291" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_120_616">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
